import React from "react";
import classes from "./index.module.scss";

export function SecondContent() {
  return (
    <section className={classes.wrapper}>
      <h3 className={classes.redText}>Lưu ý:</h3>
      <p>
        Để bảo mật thông tin, hóa đơn điện tử đã được mã hóa. Để mở file Quý
        khách vui lòng nhập mật khẩu là ngày tháng năm sinh của Quý khách đã
        cung cấp / cập nhật vào thông tin hợp đồng bảo hiểm với chúng tôi trước
        đây.
      </p>

      <div>
        <p>Ví dụ:</p>
        <p>
          1. Sinh nhật của Quý Khách là ngày 18 tháng 09 năm 1989 thì mật khẩu
          tương ứng là: 18091989
        </p>
        <p>
          2. Nếu trước đây Quý khách chỉ cung cấp năm sinh, thì ngày và tháng
          sinh sẽ mặc định là 01. Vậy mật khẩu tương ứng là: 01011989
        </p>
        <p>
          3. Nếu trước đây Quý khách chỉ cung cấp tháng và năm sinh, thì ngày
          sinh sẽ mặc định là 01. Vậy mật khẩu tương ứng là: 01091989
        </p>
      </div>

      <p>
        Nếu có bất kỳ thắc mắc nào, Quý khách vui lòng liên hệ tổng đài Phục vụ
        khách hàng{" "}
        <span className={`${classes.redText} ${classes.boldText}`}>
          18001247
        </span>{" "}
        (miễn cước) hoặc qua Email:{" "}
        <span className={`${classes.redText} ${classes.boldText}`}>
          customer.service@prudential.com.vn
        </span>
      </p>

      <p>Rất hân hạnh được phục vụ Quý khách.</p>
    </section>
  );
}
